/*******************************************************************************
 * Copyright     : Copyright (c)  2026 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc.No part may be reproduced or transmitted in any form by any
 *                 means or for anypurpose without the express written permission of Honeywell. *
 *******************************************************************************/
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, Button, Table, TableHeader, TableContent, InfoIcon, CloseIcon } from '@forge/common';

import { SoftwareDialogProps } from '../../models/softwareDialog';
import { LOCALE_CONST } from '../../utils/constants';

import './index.scss';

const SoftwareDialog: React.FC<SoftwareDialogProps> = ({
  isOpen,
  onClose,
  softwareVersion,
  downloadSize,
  tableHeaders,
  tableData,
  showFooterText = true,
  showDownload = true,
  onDownload
}) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <Modal
      backdrop
      onModalClose={onClose}
      onBackdropClick={onClose}
      className="software-dialog-modal"
      label={t(LOCALE_CONST.softwareVersionLabel)}
      title={softwareVersion}
    >
      <div className="software-dialog-content">
   
        {/* Table Section */}
        {tableHeaders && tableData && tableData.length > 0 && (
          <div className="software-dialog-table-wrapper">
            {downloadSize && (
              <span className="software-dialog-table-label">{downloadSize}</span>
            )}
            <div className="software-dialog-table-container">
              <Table>
                <TableHeader data={tableHeaders} />
                <TableContent data={tableData} />
              </Table>
            </div>
          </div>
        )}

        {/* Footer Text Section */}
        {showFooterText && (
          <div className="software-dialog-footer-wrapper">
            <div className="software-dialog-footer-text">
              <div className="software-dialog-footer-header">
                <InfoIcon strokeWidth={2} color="#64C3FF" className="software-dialog-info-icon" />
                <span className="software-dialog-footer-title">
                  {t(LOCALE_CONST.softwareUpdateInstructions)}
                </span>
              </div>
              <div className="software-dialog-footer-steps">
                <div className="software-dialog-footer-step">
                  <div className="software-dialog-footer-step-title">
                    {t(LOCALE_CONST.softwareUpdateStep1Title)}
                  </div>
                  <div className="software-dialog-footer-step-desc">
                    {t(LOCALE_CONST.softwareUpdateStep1Desc)}
                  </div>
                </div>
                <div className="software-dialog-footer-step">
                  <div className="software-dialog-footer-step-title">
                    {t(LOCALE_CONST.softwareUpdateStep2Title)}
                  </div>
                  <div className="software-dialog-footer-step-desc">
                    {t(LOCALE_CONST.softwareUpdateStep2Desc)}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Download Button Section */}
        {showDownload && (
          <div className="software-dialog-button-footer">
            <Button
              variant="primary"
              onClick={onDownload}
              className="software-dialog-download-btn"
            >
              {t(LOCALE_CONST.download)}
            </Button>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default SoftwareDialog;
